import * as squareStyles from "./TestimonialSignPostCarouselCard.square.module.scss";

import React from "react";
import CurvedBorder from "../../../components/borders/CurvedBorder";
import FuzzyBorder from "../../../components/borders/FuzzyBorder";
import { Colours } from "../../../utils/colours";
import Button from "../../common/Button";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";

export const TestimonialSignPostCarouselCard: React.FC<
	DogsTrust.SignPostCardProps
> = ({
	imgSrc,
	body,
	buttonLabel,
	buttonUrl,
	externalUrl,
	isSuccessStory,
	biggestSiblingTextCount,
}) => {
	const Border = isSuccessStory ? FuzzyBorder : CurvedBorder;
	const getSquareDetailsHeight = () => {
		return 180 + (biggestSiblingTextCount / 50) * 24;
	};

	return (
		<div className={squareStyles.squarecardwrapper}>
			<div className={squareStyles.squarecardcomponent}>
				<div className={squareStyles.squarecardimage}>
					<ProcessedImage
						className={squareStyles.squarecardcardimg}
						src={imgSrc}
						dimensions="400x300"
						width={400}
						height={300}
						alt={body}
						loading={"lazy"}
					/>
					<div className={squareStyles.squarecardborderwrapper}>
						<div className={squareStyles.squarecardborder}>
							<Border rotation={0} fill={Colours.WHITE} width={"300"} />
						</div>
					</div>
				</div>

				<div
					className={squareStyles.squarecarddetails}
					style={{ height: getSquareDetailsHeight() }}
				>
					<div className={squareStyles.squarecardsubtitle}>
						<p className={squareStyles.squarecardsubtitletext}>{body}</p>
					</div>
					<div className={squareStyles.buttonwrapper}>
						<Button
							variant={"tertiary"}
							size="small"
							url={buttonUrl}
							externalUrl={externalUrl}
						>
							{buttonLabel}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TestimonialSignPostCarouselCard;
